module.exports = __webpack_public_path__ + "img/743.852de861.png";